import AddOnPurchaseProductList from "../components/activity/add-on-purchase/AddOnPurchaseProductList";
import { ADD_ON_PURCHASE_TYPE } from "../components/activity/add-on-purchase/types";
import { ADD_ON_PURCHASE_MESSAGES } from "../components/activity/add-on-purchase/messages";
import { useAddOnPurchaseRequest } from "../components/activity/add-on-purchase/useAddOnPurchaseRequest";
import React, { useState, useContext, useEffect, useRef } from "react";
import { Button, Dropdown, Space, Drawer, Modal, message } from "antd";
import type { DrawerProps } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  activityCategoryUrl,
  activityDetailUrl,
  activityProductsUrl,
  cartCountUrl,
  shareLinkUrl,
  currentAdminReferrerPrefix,
  activityBundleListUrl,
} from "../utils/constant";
import { AppContext } from "../store";
import activityIcon from "../images/activity.svg";
import exchangeIcon from "../images/exchange.svg";
import activeActivityIcon from "../images/activeActivity.svg";
import activeExchangeIcon from "../images/activeExchange.svg";
import cartIcon from "../images/cart.svg";
import delIcon from "../images/×.svg";
import searchIcon from "../images/search.svg";
import { CaretDownOutlined } from "@ant-design/icons";
import Header from "../components/common/Header";
import ProductCard from "../components/activity/ProductCard";
import Loading from "../components/common/Loading";
import TFCPagination from "../components/common/TFCPagination";
import { formatDate, getAAId, getAuthToken, isMobile } from "../utils/common";
import { getInitialSelectedAddressKey, getSelectedSTObj } from "../utils/addressUtils";
import axios from "axios";

import MyCartDrawer from "../pages/MyCartDrawer";
import { getUniqueness, pageDetailsDataPush, subSearchDataPush } from "../utils/analyticsUtils";
import Exceptions from "../components/activity/Exceptions";
import {
  getFilteredCategories,
  getTempFilterCatetory,
  hasSelected,
} from "Utils/activityHelper";
import { logOperation } from "Utils/operationLogUtils";
import FooterNavBar from "Components/common/FooterNavBar";
import Footer from "Components/common/Footer";
import BundleList from "Components/activity/BundleList";
import BundleCard from "Components/activity/BundleCard";
import { Bundle } from "src/types/global";
import RichTextContent from "Components/RichTextContent";
import { buildActivityCartCache } from "Utils/richTextS3ImageUtil";

const Activity: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const bundleId = searchParams.get("bundleId");
  const refreshFilter = searchParams.get("refresh");
  const [loadingCatList, setLoadingCatList] = useState<boolean>(true);
  const { activityId } = useParams<{ activityId: string }>();  
  const currentST = searchParams.get("currentST");
  const {
    loginState,
    cartCount,
    setCartCount,
    refreshCartData,
    setActivityPermissionMeta,
    setSelectedAddressKey,
    selectedAddressKey,
  } =
    useContext(AppContext);
  const [categoryList, setCategoryList] = useState<any>();
  const [activityDetail, setActivityDetail] = useState<any>();
  const [keyword, setKeyword] = useState<string>("");
  const [queryKey, setQuerykey] = useState<{
    value: string;
    trigger: "init" | "cache" | "search";
  }>({ value: "", trigger: "cache" });
  const [productData, setProductData] = useState<any>();
  const [activityMsg, setActivityMsg] = useState<string>("");
  const [filteredCategories, setFilteredCategories] = useState<any>({
    activeTab: "activity",
    filteredMap: new Map(),
    pageConf: { pageNum: 1, pageSize: 15 },
  });
  const [loading, setLoading] = React.useState<boolean>(true);
  const [loadingActivity, setLoadingActivity] = React.useState<boolean>(true);
  const [openCartDrawer, setOpenCartDrawer] = useState(false);
  const [placement] = useState<DrawerProps["placement"]>("right");
  const userInfo = loginState?.user?.user;
  const [referrerValue] = React.useState<string | undefined>(document.referrer);
  const [currentBundle, setCurrentBundle] = useState<Bundle | undefined>();
  const [bundleList, setBundleList] = useState<Bundle[]>([]);
  const [shortLink, setShortLink] = React.useState<string>();
  const [showShortLinkModal, setShowShortLinkModal] =
    React.useState<boolean>(false);
  const [analaticData] = useState<any>({});

  const isAddOnPurchase = activityDetail?.activityBasicType === ADD_ON_PURCHASE_TYPE;
  const addOnIdentity = [activityId, loginState.status, loginState.token, selectedAddressKey].join("|");
  const fetchAddOnPurchaseProducts = useAddOnPurchaseRequest(addOnIdentity);
  const addOnListIdentity = useRef("");

  useEffect(() => {
    if (loginState?.status !== "login") {
      return;
    }
    if (!currentST) {
      return;
    }
    const nextAddressKey = getInitialSelectedAddressKey(loginState, currentST);
    if (!nextAddressKey) {
      return;
    }
    if (localStorage.getItem("selectedAddressKey") === nextAddressKey) {
      setSelectedAddressKey(nextAddressKey);
    } else {
      localStorage.setItem("selectedAddressKey", nextAddressKey);
      setSelectedAddressKey(nextAddressKey);
    }
    const nextSearchParams = new URLSearchParams(location.search);
    nextSearchParams.delete("currentST");
    navigate(
      {
        pathname: location.pathname,
        search: nextSearchParams.toString()
          ? `?${nextSearchParams.toString()}`
          : "",
      },
      { replace: true }
    );
  }, [
    currentST,
    location.pathname,
    location.search,
    loginState,
    navigate,
    setSelectedAddressKey,
  ]);

  useEffect(() => {
    if (isMobile()) {
      console.log("isMobile", true);
      // keep all search params
      const searchParams = new URLSearchParams(location.search);
      navigate(`/m/${activityId}?${searchParams.toString()}`, {
        replace: true,
      });
      return;
    }
    (window as any).currentCampaignId = activityId;
    const loginStatus = loginState?.status;
    if ((loginStatus === "login" || loginStatus === "failed") && activityId) {
      localStorage.setItem("currentCampaignId", activityId);
      !activityDetail && getActivityDetail();
    }
    if (loginStatus === "login") {
      getCartCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState, activityId, filteredCategories.activeTab]);
  useEffect(() => {
    initFilter();
  }, []);
  useEffect(() => {
    if (refreshFilter) {
      console.log("refreshFilter", refreshFilter);
      initFilter();
    }
  }, [refreshFilter]);

  const initFilter = () => {
    const filter = searchParams.get("filter");
    if (filter) {
      const filterObj = JSON.parse(filter);
      const { pageNum, pageSize, tab, categories, queryKey } = filterObj;
      if (queryKey) {
        console.log("queryKey", queryKey);
        setKeyword(queryKey);
        setQuerykey({ value: queryKey, trigger: "init" });
      }
      const pageConf = { pageNum: pageNum || 1, pageSize: pageSize || 15 };
      const categoriesMap = new Map();
      categories?.forEach((category: string) => {
        const [pName, sName] = category.split(":");
        if (sName) {
          let pCatMap = categoriesMap.get(pName) || new Map();
          pCatMap.set(sName, { categoryName: sName, pName });
          categoriesMap.set(pName, pCatMap);
        } else {
          categoriesMap.set(pName, "all");
        }
      });
      setFilteredCategories({
        activeTab: tab,
        filteredMap: categoriesMap,
        pageConf,
      });
    }
  };
  useEffect(() => {
    if (!activityDetail) return;
    if (activityDetail?.activityBasicType === "bundle_promotion") {
      return;
    }
    getCategoryList(filteredCategories.activeTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredCategories.activeTab, activityDetail?.activityBasicType]);
  useEffect(() => {
    if (loginState?.status !== "idle" && activityId && activityDetail) {
      !loadingCatList && getProductList();
      getBundleList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loginState,
    activityDetail,
    loadingCatList,
    activityId,
    filteredCategories,
    isAddOnPurchase ? selectedAddressKey : undefined,
  ]);
  const resetActivityRequestState = () => {
    setActivityMsg("");
    setActivityDetail(undefined);
    setLoadingActivity(true);
    setActivityPermissionMeta({
      activityId,
      customerDataType: undefined,
    });
  };

  const getActivityDetail = async () => {
    try {
      resetActivityRequestState();
      const selectedST = getSelectedSTObj(loginState);
      const activityDetailRequestUrl = selectedST?.accountNumber
        ? `${activityDetailUrl}/${activityId}?customerStNumber=${selectedST.accountNumber}`
        : `${activityDetailUrl}/${activityId}`;
      const resp = await axios(
        activityDetailRequestUrl,
        {
          method: "GET",
          headers: {
            Authorization: getAuthToken(),
            "Content-Type": "application/json",
            "user-type":
              referrerValue && referrerValue === currentAdminReferrerPrefix
                ? "admin"
                : undefined,
          },
        }
      );
      if (resp.status === 200) {
        const respData = resp.data;
        if (respData.status === "success") {
          const buzData = respData.data;
          setActivityDetail(buzData);
          localStorage.setItem(
            "activityDetail",
            JSON.stringify(buildActivityCartCache(buzData))
          );
          setActivityPermissionMeta({
            activityId,
            customerDataType: buzData?.customerDataType,
          });
          setLoadingActivity(false);
          if (
            buzData.activityBasicType !== "low_exchange" &&
            filteredCategories.activeTab === "exchange"
          ) {
            setFilteredCategories({
              ...filteredCategories,
              activeTab: "activity",
              filteredMap: new Map(),
            });
          }
          setOpenCartDrawer(!!location.state?.openCartDrawer);
        } else {
          console.log("getActivityDetail failed");
          setActivityMsg(respData.status);
        }
      }
      const aaPageDetail = {
        type: "campaigns",
        name: `campaigns:${filteredCategories.activeTab}`,
      };
      pageDetailsDataPush(aaPageDetail);
      setLoadingActivity(false);
    } catch (err) {
      console.log(err);
      setLoadingActivity(false);
    }
  };

  const getCategoryList = async (type: string) => {
    if (activityDetail?.activityBasicType === "bundle_promotion") return;
    setLoadingCatList(true);
    try {
      const selectedST = getSelectedSTObj(loginState);
      const categoryListRequestUrl = selectedST?.accountNumber
        ? `${activityCategoryUrl}?activityId=${activityId}&type=${type}&customerStNumber=${selectedST.accountNumber}`
        : `${activityCategoryUrl}?activityId=${activityId}&type=${type}`;
      const resp = await axios(
        categoryListRequestUrl,
        {
          method: "GET",
          headers: {
            Authorization: getAuthToken(),
            "Content-Type": "application/json",
          },
        }
      );
      if (resp.status === 200) {
        const respData = resp.data;
        if (respData.status === "success") {
          const buzData = respData.data || [];
          buzData?.forEach((category: any) => {
            if (!category.subCategoryList) {
              category.subCategoryList = [];
            }
            if (category.subCategoryList.length > 0) {
              category.subCategoryList.unshift({
                id: "all",
                categoryName: "全部",
              });
            }
          });
          setCategoryList(buzData);
          let tempFilteredMap = getTempFilterCatetory(
            buzData,
            filteredCategories
          ); //根据新的categoryList结果，重置filteredCategories.filteredMap

          if (tempFilteredMap !== filteredCategories.filteredMap) {
            setFilteredCategories({
              ...filteredCategories,
              filteredMap: tempFilteredMap,
            });
          }
          setLoadingCatList(false);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleAnalaticSearch = (type: number, searchText: string, analaticData: any) => {
    if (analaticData.step == 1) {
      const searchPayload: any = {
        eventType: type ? "search:successful" : "search:failure",
        searchType: "sub search:marketing",
        keyword: searchText,
        unique: analaticData.unique,
      };
      if (Object.keys(analaticData.filters).length > 0) {
        searchPayload.filters = analaticData.filters;
      }
      subSearchDataPush(searchPayload);
      analaticData.step = 2;
    }
  };
  const getProductList = async () => {
    if (isAddOnPurchase && addOnListIdentity.current !== addOnIdentity) {
      const customerChanged = addOnListIdentity.current !== "";
      addOnListIdentity.current = addOnIdentity;
      setProductData(undefined);
      if (customerChanged && filteredCategories.pageConf.pageNum !== 1) {
        setFilteredCategories((previous: typeof filteredCategories) => ({
          ...previous, pageConf: { ...previous.pageConf, pageNum: 1 },
        }));
        return;
      }
    }

    if (activityDetail?.activityBasicType === "bundle_promotion") return;
    const { categories, memoCat } = getFilteredCategories(
      filteredCategories.filteredMap,
      categoryList
    );
    const selectedST = getSelectedSTObj(loginState);
    const pageConf = filteredCategories.pageConf;
    const reqBody = {
      activityId,
      type: filteredCategories.activeTab,
      categories,
      queryKey: queryKey.value,
      ...pageConf,
      shipTo: selectedST?.accountNumber,
    };
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete("refresh");
    searchParams.set(
      "filter",
      JSON.stringify({
        ...pageConf,
        tab: filteredCategories.activeTab,
        categories: memoCat,
        queryKey: queryKey.value,
      })
    );
    const unique = getUniqueness(reqBody.keyword);

    analaticData.unique = unique;
    const filters = { category: categories }
    analaticData.filters = filters
    if (!pageConf?.pageNum || pageConf?.pageNum == 1) {
      if (queryKey.trigger === "search" && reqBody.queryKey) {
        analaticData.step = 1;
        subSearchDataPush({
          eventType: "search:submitted",
          searchType: "sub search:marketing",
          keyword: reqBody.queryKey,
          unique
        })
      }
      if (analaticData.trigger === "filter") {
        analaticData.step = 1;
        subSearchDataPush({
          eventType: "search:filtered",
          searchType: 'sub search:marketing',
          unique,
          filters
        })
      }
      if (analaticData.trigger === "reset") {
        analaticData.step = 1;
        subSearchDataPush({
          eventType: "search:resetFilters",
          searchType: 'sub search:marketing',
          keyword: reqBody.queryKey,
          unique,
          filters
        })
      }
    }
    navigate(`?${searchParams.toString()}`, { replace: true });
    setLoading(true);
    if (isAddOnPurchase) {
      setProductData(undefined);
    }
    try {
      const requestConfig = {
        method: "POST",
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
          "user-type":
            referrerValue && referrerValue === currentAdminReferrerPrefix
              ? "admin"
              : undefined,
        },
        data: reqBody,
      };
      const resp = isAddOnPurchase
        ? await fetchAddOnPurchaseProducts(reqBody, requestConfig.headers)
        : await axios(activityProductsUrl, requestConfig);
      if (!resp) return;
      if (resp.status === 200) {
        const respData = resp.data;
        if (respData.status === "success") {
          const buzData = respData.data;
          setProductData(buzData);
          shortLinkRefreshPageObj(buzData, categoryList);
          if (queryKey.trigger === "search") {
            if (buzData.total > 0) {
              logOperation({
                opUser: userInfo?.userId || getAAId(),
                opTarget: "Search_Product",
                opTargetId:
                  memoCat.length > 0
                    ? JSON.stringify({
                      categories: memoCat,
                      queryKey: queryKey.value,
                    })
                    : queryKey.value,
                opContent:
                  filteredCategories.activeTab === "activity"
                    ? "Activity_Detail_Results"
                    : "Exchange_Detail_Results",
              });

            } else {
              logOperation({
                opUser: userInfo?.userId || getAAId(),
                opTarget: "Search_Product",
                opTargetId:
                  memoCat.length > 0
                    ? JSON.stringify({
                      categories: memoCat,
                      queryKey: queryKey.value,
                    })
                    : queryKey.value,
                opContent:
                  filteredCategories.activeTab === "activity"
                    ? "Activity_Detail_NoResults"
                    : "Exchange_Detail_NoResults",
              });
            }
          }
          if (reqBody.pageNum == 1) {
            if (buzData.total > 0) {
              handleAnalaticSearch(1, reqBody.queryKey, analaticData)
            } else {
              handleAnalaticSearch(0, reqBody.queryKey, analaticData)
            }
          }
          queryKey.trigger = "cache";
          analaticData.trigger && (analaticData.trigger = "");
        }
      }
      setLoading(false);
    } catch (err) {
      if (isAddOnPurchase) message.error(ADD_ON_PURCHASE_MESSAGES.queryFailed);
      console.log(err);
      setLoading(false);
    }
  };
  const getBundleList = async () => {
    if (activityDetail?.activityBasicType !== "bundle_promotion") return;
    // setLoading(false);
    // setBundleList(bundleRespData.data);
    // setCurrentBundle(bundleRespData.data[0]);
    // return;
    try {
      const selectedST = getSelectedSTObj(loginState);
      const bundleListRequestUrl = selectedST?.accountNumber
        ? `${activityBundleListUrl}?activityId=${activityId}&customerStNumber=${selectedST.accountNumber}`
        : `${activityBundleListUrl}?activityId=${activityId}`;
      const resp = await axios(
        bundleListRequestUrl,
        {
          method: "GET",
          headers: {
            Authorization: getAuthToken(),
            "Content-Type": "application/json",
            "user-type":
              referrerValue && referrerValue === currentAdminReferrerPrefix
                ? "admin"
                : undefined,
          },
        }
      );
      if (resp.status === 200) {
        const respData = resp.data;
        console.log("getBundleList respData", respData);
        if (respData.status === "success") {
          const buzData = respData.data;
          console.log("getBundleList buzData", buzData);
          setBundleList(buzData);
          setCurrentBundle(bundleId ? buzData.find((item: any) => item.id === parseInt(bundleId)) || buzData[0] : buzData[0]);
        }
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const shortLinkRefreshPageObj = (buzData: any, categoryList: any) => {
    const searchParams = new URLSearchParams(location.search);
    const filter = searchParams.get("filter");
    if (filter) {
      const filterObj = JSON.parse(filter);
      const { pageNum, pageSize, tab, categories, queryKey } = filterObj;

      if (pageNum > buzData.pageTotal) {
        setFilteredCategories({
          ...filteredCategories,
          pageConf: {
            pageNum:
              pageNum > buzData.pageTotal ? buzData.pageTotal : buzData.pageNum,
            pageSize: buzData.pageSize,
          },
        });
      }
    }
  };

  const getCartCount = async () => {
    try {
      const selectedST = getSelectedSTObj(loginState);
      const cartCountRequestUrl = selectedST?.accountNumber
        ? `${cartCountUrl}?activityId=${activityId}&customerStNumber=${selectedST.accountNumber}`
        : `${cartCountUrl}?activityId=${activityId}`;
      const resp = await axios(cartCountRequestUrl, {
        method: "GET",
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
      });
      if (resp.status === 200) {
        const respData = resp.data;
        if (respData.status === "success") {
          setCartCount(respData.data || 0);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const showMyCartDrawer = () => {
    console.log("cart click");
    setOpenCartDrawer(true);
    refreshCartData();
    const aaPageDetail = {
      type: "campaigns",
      name: "campaigns:myCart",
    };
    pageDetailsDataPush(aaPageDetail);
  };

  const closeMyCartDrawer = () => {
    setOpenCartDrawer(false);
  };

  const handleRefreshActivityData = () => {
    resetActivityRequestState();
    setFilteredCategories((prev: any) => ({
      ...prev,
      pageConf: { pageNum: 1, pageSize: prev.pageConf.pageSize },
    }));
    getActivityDetail();
  };

  const generateShortLink = async () => {
    const reqBody = {
      url: window.location.href,
    };
    try {
      const resp = await axios(shareLinkUrl, {
        method: "POST",
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
          "user-type":
            referrerValue && referrerValue === currentAdminReferrerPrefix
              ? "admin"
              : undefined,
        },
        data: reqBody,
      });
      if (resp.status === 200) {
        const respData = resp.data;
        if (respData.status === "success") {
          setShortLink(respData.data);
          setShowShortLinkModal(true);
        } else {
          onCloseCopyShortLinkModal();
        }
        console.log("generateShortLink respData", respData);
      }
    } catch (err) {
      console.log(err);
      onCloseCopyShortLinkModal();
    }
  };

  const onCloseCopyShortLinkModal = () => {
    setShortLink("");
    setShowShortLinkModal(false);
  };

  const copyShortLinkHandle = () => {
    // 保存当前焦点元素
    const activeElement = document.activeElement;
    if (shortLink !== undefined) {
      try {
        // 将焦点设置到某个元素上(例如 body)
        document.body.focus();
        navigator.clipboard?.writeText(shortLink);
        message.success("复制成功");
      } catch (err) {
        console.error("Error in copying text: ", err);
      } finally {
        // 将焦点恢复到原来的元素
        if (activeElement instanceof HTMLElement) {
          activeElement.focus();
        }
      }
    } else {
      message.error("生成短链有误");
    }
    onCloseCopyShortLinkModal();
  };

  const onTabChange = (tab: string) => {
    if (filteredCategories.activeTab !== tab) {
      setFilteredCategories({
        activeTab: tab,
        filteredMap: new Map(),
        pageConf: {
          pageNum: 1,
          pageSize: filteredCategories.pageConf.pageSize,
        },
      });
      const aaPageDetail = {
        type: "campaigns",
        name: `campaigns:${tab}`,
      };
      pageDetailsDataPush(aaPageDetail);
      logOperation({
        opUser: userInfo?.userId || getAAId(),
        opTarget: "Exchange_Promo_Tap",
        opTargetId: tab,
        opContent: "Exchange_Promo_Tap",
      });
    }
  };
  const addToCartCallbak = () => {
    setOpenCartDrawer(true);
    refreshCartData();
  };
  if (activityMsg) {
    return (
      <>
        <Header
          page="Activity_Detail"
          onRefreshData={handleRefreshActivityData as any}
        ></Header>
        <div
          className="pageContentContainer"
          style={{
            height: "calc(100vh - 270px)",
            textAlign: "center",
            fontSize: "20px",
          }}
        >
          <Exceptions loginState={loginState} status={activityMsg}></Exceptions>
        </div>
        <FooterNavBar loginState={loginState} />
        <Footer />
      </>
    );
  }
  if (
    loadingActivity ||
    (activityDetail?.activityBasicType !== "bundle_promotion" && !categoryList)
  ) {
    return <Loading />;
  }
  const bannerImg = activityDetail?.images?.find(
    (imgItem: any) => imgItem.type === "campaigns"
  );
  const onBundleQtyChange = () => {
    getBundleList();
    setCartCount(0);
  };
  const cartTitle =
    activityDetail?.activityBasicType === "bundle_promotion"
      ? "已选套装"
      : "已选产品";
  return (
    <>
      <Header
        page="Activity_Detail"
        onRefreshData={handleRefreshActivityData as any}
      />
      <div className="activityPageWrapper">
        {/* <div className="banner-reminder">
          <label className="reminder-info">{"温馨提醒 "}</label>
          {
            "该促销优惠仅限在当前页面加购产品才可享受，进入产品详情页或其他页面无法享受。"
          }
        </div> */}
        <div className="bannerWrapper">
          <div className="bannerImgWrapper">
            <img src={bannerImg?.imageUrl || ""} alt="banner" />
          </div>
          <div className="floatWrapper pageContentContainer">
            <div className="contentWrapper">
              <div>
                <h1
                  className="title"
                  style={{ color: activityDetail?.fontColor || "#fff" }}
                >
                  {activityDetail?.title}
                </h1>
                <div className="activityInfo">
                  <div
                    className="timeRanger"
                    style={{ color: activityDetail?.fontColor || "#fff" }}
                  >
                    <span>{formatDate(activityDetail?.startTime)}</span> -{" "}
                    <span>{formatDate(activityDetail?.endTime)}</span>
                  </div>
                  <div className="hotwords">
                    <Space>
                      {activityDetail?.hotWords?.map((word: string) => {
                        return (
                          <span key={word} className="hotWord">
                            {word}
                          </span>
                        );
                      })}
                    </Space>
                  </div>
                </div>
                <RichTextContent
                  as="p"
                  className="summary"
                  style={{ color: activityDetail?.fontColor || "#fff" }}
                  html={activityDetail?.summary}
                />
              </div>
              <div className="bottomBlock">
                <Button
                  href="#activitySpec"
                  className="primaryBtn"
                  onClick={() => {
                    logOperation({
                      opUser: userInfo?.userId || getAAId(),
                      opTarget: "Activity_Specification",
                      opTargetId: "",
                      opContent: "Activity_Specification",
                    });
                  }}
                >
                  活动细则
                </Button>
              </div>
            </div>
          </div>
        </div>
        {loading && <Loading />}
        <>
          <div className="filterWrapper1">
            <div className="navWrapper pageContentContainer">
              {activityDetail.activityBasicType === "bundle_promotion" ? (
                <BundleList
                  bundles={bundleList}
                  currentBundle={currentBundle}
                  onClick={(bundle: Bundle) => {
                    console.log(bundle);
                    setCurrentBundle(bundle);
                    const queryParams = new URLSearchParams(location.search)
                    queryParams.set("bundleId", bundle.id.toString())
                    navigate(`${location.pathname}?${queryParams.toString()}`, {replace: true})
                  }}
                />
              ) : (
                <div className="tabsInner">
                  <div
                    className={`tabItem ${filteredCategories.activeTab === "activity"
                      ? "active"
                      : ""
                      }`}
                    onClick={() => {
                      onTabChange("activity");
                    }}
                  >
                    <div className="navBtn">
                      <img
                        alt="activity"
                        src={
                          filteredCategories.activeTab === "activity"
                            ? activeActivityIcon
                            : activityIcon
                        }
                      ></img>
                      <span>{activityDetail?.activityTypeName}</span>
                    </div>
                    <div className="navDesc">
                      {activityDetail?.activityTypeDescription}
                    </div>
                  </div>
                  {activityDetail?.activityBasicType === "low_exchange" && (
                    <div
                      className={`tabItem ${filteredCategories.activeTab === "exchange"
                        ? "active"
                        : ""
                        }`}
                      onClick={() => {
                        onTabChange("exchange");
                      }}
                    >
                      <div className="navBtn">
                        <img
                          alt="exchange"
                          src={
                            filteredCategories.activeTab === "exchange"
                              ? activeExchangeIcon
                              : exchangeIcon
                          }
                        ></img>
                        <span>
                          {activityDetail?.exchangeTypeName || "换购"}
                        </span>
                      </div>
                      <div className="navDesc">
                        {activityDetail?.exchangeTypeDescription}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {referrerValue &&
                referrerValue === currentAdminReferrerPrefix && (
                  <div className="generate-short-link-wrapper">
                    <div
                      className="generate-short-nav-btn"
                      onClick={() => {
                        generateShortLink();
                      }}
                    >
                      <span style={{ whiteSpace: "nowrap" }}>生成短链</span>
                    </div>
                  </div>
                )}
              {loginState.status === "login" && (
                <div className="cartEntryWrapper">
                  <div className="navBtn" onClick={showMyCartDrawer}>
                    <img src={cartIcon} alt={cartTitle}></img>
                    <span
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      {cartTitle}
                    </span>
                    <span className="cartBadge">{cartCount}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {activityDetail.activityBasicType === "bundle_promotion" ? (
            <div className="productsWrapper pageContentContainer">
              <BundleCard
                key={currentBundle?.id}
                bundle={currentBundle}
                activityId={activityId}
                previewFlag={activityDetail.previewFlag}
                onAddToCart={addToCartCallbak}
              />
            </div>
          ) : (
            <>
              <div className="filterWrapper2">
                <div className="navWrapper2 pageContentContainer">
                  {categoryList?.length > 0 && (
                    <div className="categoryWrapper">
                      <Space
                        id="categoryWrapper"
                        style={{ flexWrap: "wrap", position: "relative" }}
                      >
                        {categoryList?.map((category: any) => {
                          if (!category.subCategoryList.length) {
                            const filterMap = filteredCategories.filteredMap;
                            const selected = hasSelected(filterMap, category,);
                            return (
                              <div
                                key={category.id}
                                className={"dropdownItemWrapper"}
                                id={`dropdown${category.id}`}
                                onClick={() => {
                                  analaticData.trigger = "filter";
                                  if (selected) {
                                    filterMap.delete(category.categoryName);
                                    setFilteredCategories({
                                      ...filteredCategories,
                                      filteredMap: new Map(filterMap),
                                    });
                                    return;
                                  }
                                  filterMap.set(
                                    category.categoryName,
                                    "all"
                                  );
                                  setFilteredCategories({
                                    ...filteredCategories,
                                    filteredMap: new Map(filterMap),
                                  });
                                }}
                              >
                                <Button className={selected ? "selected" : ""}>{category.categoryName}</Button>
                              </div>
                            );
                          }
                          return (
                            <div
                              key={category.id}
                              className="dropdownItemWrapper"
                              style={{ position: "relative" }}
                              id={`dropdown${category.id}`}
                            >
                              <Dropdown
                                autoAdjustOverflow={false}
                                overlayClassName="categoryDropdownWrapper"
                                key={category.id}
                                placement="bottomLeft"
                                trigger={["click"]}
                                getPopupContainer={(
                                  triggerNode: HTMLElement
                                ) => {
                                  const node = document.getElementById(
                                    `dropdown${category.id}`
                                  );
                                  if (node) return node;
                                  return document.body;
                                }}
                                menu={{
                                  items: category.subCategoryList?.map(
                                    (subCategory: any) => {
                                      const selected = hasSelected(filteredCategories.filteredMap, category, subCategory);
                                      return {
                                        label: subCategory.categoryName,
                                        key: subCategory.id,
                                        className: !!selected ? "selected" : "",
                                        onClick: () => {
                                          analaticData.trigger = "filter"
                                          const filterMap =
                                            filteredCategories.filteredMap;
                                          if (subCategory.id === "all") {
                                            filterMap.set(
                                              category.categoryName,
                                              "all"
                                            );
                                          } else {
                                            let sCatMap = filterMap.get(
                                              category.categoryName
                                            );
                                            if (
                                              !sCatMap ||
                                              typeof sCatMap === "string"
                                            ) {
                                              sCatMap = new Map();
                                              filterMap.set(
                                                category.categoryName,
                                                sCatMap
                                              );
                                            }
                                            sCatMap.set(
                                              subCategory.categoryName,
                                              {
                                                categoryName:
                                                  subCategory.categoryName,
                                                pName: category.categoryName,
                                              }
                                            );
                                          }
                                          setFilteredCategories({
                                            ...filteredCategories,
                                            filteredMap: new Map(filterMap),
                                          });
                                        },
                                      };
                                    }
                                  ),
                                }}
                              >
                                <Button>
                                  <Space>
                                    {category.categoryName}
                                    <CaretDownOutlined />
                                  </Space>
                                </Button>
                              </Dropdown>
                            </div>
                          );
                        })}
                      </Space>
                    </div>
                  )}
                  <div className="searchSecWrapper">
                    <div className="searchWrapper">
                      <span className="searchInput">
                        <span className="icon">
                          <img src={searchIcon} alt="search"></img>
                        </span>
                        <input
                          className="input"
                          value={keyword}
                          onChange={(e) => {
                            setKeyword(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              analaticData.trigger = "search";
                              setQuerykey({
                                value: keyword,
                                trigger: "search",
                              });
                              setFilteredCategories({
                                ...filteredCategories,
                                pageConf: {
                                  pageNum: 1,
                                  pageSize:
                                    filteredCategories.pageConf.pageSize,
                                },
                              });
                            }
                          }}
                        ></input>
                      </span>
                      <Button
                        className="primaryBtn"
                        onClick={() => {
                          setQuerykey({ value: keyword, trigger: "search" });
                          setFilteredCategories({
                            ...filteredCategories,
                            pageConf: {
                              pageNum: 1,
                              pageSize: filteredCategories.pageConf.pageSize,
                            },
                          });
                        }}
                      >
                        搜索
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="productsWrapper pageContentContainer">
                <div className="filteredInfoWrapper">
                  <span className="resultTotal">
                    共有{productData?.total || "0"}个产品
                  </span>
                  <Space>
                    {filteredCategories.filteredMap.size > 0 &&
                      Array.from(filteredCategories.filteredMap)?.map(
                        ([key, filteredCat]: any) => {
                          // key is the category id, filteredCat is the category name
                          if (typeof filteredCat === "string") {
                            return (
                              <span
                                key={key}
                                className="deletableBtn"
                                onClick={() => {
                                  console.log(
                                    "filteredCat clicked",
                                    key,
                                    filteredCat
                                  );
                                  analaticData.trigger = "reset";
                                  const filterMap =
                                    filteredCategories.filteredMap;
                                  filterMap.delete(key);
                                  setFilteredCategories({
                                    ...filteredCategories,
                                    filteredMap: new Map(filterMap),
                                    pageConf: {
                                      pageNum: 1,
                                      pageSize:
                                        filteredCategories.pageConf.pageSize,
                                    },
                                  });
                                }}
                              >
                                {key}
                                <span className="delIcon">
                                  <img src={delIcon} alt="delete"></img>
                                </span>
                              </span>
                            );
                          } else {
                            return Array.from(filteredCat)?.map(
                              ([subKey, subCat]: any) => {
                                return (
                                  <span
                                    key={subCat.pName + subKey}
                                    className="deletableBtn"
                                    onClick={() => {
                                      console.log(
                                        "filteredCat clicked",
                                        subCat
                                      );
                                      analaticData.trigger = "reset";
                                      const filterMap =
                                        filteredCategories.filteredMap;
                                      let pCatMap = filterMap.get(key);
                                      pCatMap.delete(subKey);
                                      if (pCatMap.size === 0) {
                                        filterMap.delete(key);
                                      } else {
                                        filterMap.set(key, pCatMap);
                                      }
                                      setFilteredCategories({
                                        ...filteredCategories,
                                        filteredMap: new Map(filterMap),
                                        pageConf: {
                                          pageNum: 1,
                                          pageSize:
                                            filteredCategories.pageConf
                                              .pageSize,
                                        },
                                      });
                                    }}
                                  >
                                    {subCat.categoryName}
                                    <span className="delIcon">
                                      <img src={delIcon} alt="delete"></img>
                                    </span>
                                  </span>
                                );
                              }
                            );
                          }
                        }
                      )}
                    {queryKey.value ? (
                      <span
                        className="deletableBtn"
                        onClick={() => {
                          analaticData.trigger = "reset";
                          setKeyword("");
                          setQuerykey({ value: "", trigger: "cache" });
                          setFilteredCategories({
                            ...filteredCategories,
                            pageConf: {
                              pageNum: 1,
                              pageSize: filteredCategories.pageConf.pageSize,
                            },
                          });
                        }}
                      >
                        关键字：{queryKey.value}
                        <span className="delIcon">
                          <img src={delIcon} alt="delete"></img>
                        </span>
                      </span>
                    ) : null}
                    {queryKey.value ||
                      filteredCategories.filteredMap.size > 0 ? (
                      <span
                        className="delAllBtn"
                        onClick={() => {
                          analaticData.trigger = "reset"
                          setFilteredCategories({
                            activeTab: filteredCategories.activeTab,
                            filteredMap: new Map(),
                            pageConf: {
                              pageNum: 1,
                              pageSize: filteredCategories.pageConf.pageSize,
                            },
                          });
                          setKeyword("");
                          setQuerykey({ value: "", trigger: "cache" });
                        }}
                      >
                        清除全部
                      </span>
                    ) : null}
                  </Space>
                </div>
                {!productData?.data?.length && !loading && (
                  <div className="noDataWrapper">
                    抱歉！未找到符合您需求的产品。
                  </div>
                )}
                {isAddOnPurchase ? (
                  <AddOnPurchaseProductList activityId={activityId} loginState={loginState}
                    products={(productData?.data || [])} previewFlag={activityDetail?.previewFlag} onAddToCart={addToCartCallbak} />
                ) : (
                  <div className="productList">
                  {productData?.data?.map((product: any) => {
                    return (
                      <ProductCard
                        activityId={activityId}
                        tab={filteredCategories.activeTab}
                        loginState={loginState}
                        key={(product.category || "") + product.sku}
                        product={product}
                        previewFlag={activityDetail?.previewFlag}
                        onAddToCart={addToCartCallbak}
                      />
                    );
                  })}
                </div>
                )}
                {productData?.data?.length > 0 && (
                  <TFCPagination
                    pageSize={filteredCategories.pageConf?.pageSize}
                    total={productData?.total}
                    currentPage={filteredCategories.pageConf?.pageNum}
                    onPageChange={(page: number, pageSize: number) => {
                      console.log("page", page, pageSize);
                      setFilteredCategories({
                        ...filteredCategories,
                        pageConf: { pageNum: page, pageSize },
                      });
                    }}
                  />
                )}
              </div>
            </>
          )}
          <div className="activitySpecWrapper">
            <div id="activitySpec" className="pageContentContainer">
              <h2
                className="title"
                onClick={() => {
                  logOperation({
                    opUser: userInfo?.userId || getAAId(),
                    opTarget: "Activity_Specification",
                    opTargetId: "",
                    opContent: "Activity_Specification",
                  });
                }}
              >
                活动细则
              </h2>
              <RichTextContent html={activityDetail?.description || ""} />
            </div>
          </div>
        </>
        <Drawer
          title={cartTitle}
          placement={placement}
          width={440}
          onClose={closeMyCartDrawer}
          open={openCartDrawer}
          className="my-cart-drawer"
          rootClassName="my-cart-drawer-root"
        >
          <MyCartDrawer
            location={location}
            open={openCartDrawer}
            activityId={activityId}
            setOpenCartDrawer={setOpenCartDrawer}
            filteredCategories={filteredCategories}
            activityDetail={activityDetail}
            setFilteredCategories={setFilteredCategories}
            onBundleQtyChange={onBundleQtyChange}
          />
        </Drawer>
        <Modal
          open={showShortLinkModal}
          onCancel={onCloseCopyShortLinkModal}
          onOk={copyShortLinkHandle}
          title="复制短链"
          className="add-shipping-address-modal"
          okText="复制"
          cancelText="取消"
        >
          <p>{shortLink}</p>
        </Modal>
      </div>
      <FooterNavBar loginState={loginState} />
      <Footer />
    </>
  );
};
export default Activity;
